import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialTabs, SectionSubHeader } from 'components/layout'
import { ActivityProgress } from 'components/misc'

const secondTab = {
  id: 1,
  label: 'Overview',
  intlKey: 'tabs.overview',
  to: 'overview'
}

export default class ParticipantSubHeader extends Component {
  static propTypes = {
    isMajor: PropTypes.bool,
    completedPercentage: PropTypes.number,
    name: PropTypes.string,
    activityRoute: PropTypes.string,
    activitySection: PropTypes.string,
    avatar: PropTypes.string,
    completionText: PropTypes.string,
    hideProgress: PropTypes.bool,
    showReport: PropTypes.bool
  }

  static defaultProps = {
    isMajor: false,
    activityType: null,
    activitySection: null,
    completedPercentage: null
  }

  render() {
    const {
      isMajor,
      name,
      avatar,
      activityRoute,
      activitySection,
      completedPercentage,
      completionText,
      hideProgress,
      showReport
    } = this.props

    const firstTab = {
      id: 0,
      label: showReport ? 'Report' : 'Logs',
      intlKey: showReport ? 'tabs.report' : 'tabs.logs',
      to: showReport ? 'report' : 'logs'
    }

    return (
      <SectionSubHeader
        title={name}
        subtitle={completionText}
        isMajor={isMajor}
        avatar={avatar}
        activitySection={activitySection}
        progress={
          hideProgress ? null : (
            <ActivityProgress white completedPercentage={completedPercentage} />
          )
        }
        hasAvatar
        tabs={
          <MaterialTabs root={activityRoute} items={[firstTab, secondTab]} />
        }
      />
    )
  }
}
